import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    Input,
    OnChanges,
} from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';
import { FormControl } from '@angular/forms';



interface Item {   tipo: number;   parent: string;   childID: number;   texto: string; }
 
@Component({
    selector: 'app-attributes-filter',
    templateUrl: './attributes-filter.component.html',
    styleUrls: ['./attributes-filter.component.scss'],
    standalone: false
})
export class AttributesFilterComponent implements OnInit, OnChanges {
    @Input() AttributeModal: any[];
    @Output() AttributeSelected = new EventEmitter();
    @Output() AttributeModalChanged = new EventEmitter();
    attributos$: any[];
    padres : any;
    parents: string[] = [];
    childrenMap: { [key: string]: Item[] } = {};
    selectedParent: string | null = null;
    children: Item[] = [];
    showChildren = false;
    bajaSelected = false;


    constructor(
        public selectionGenericService: SelectionGenericService,
        public empresaTreeViewService: EmpresaTreeViewService,
        private sharedService: SharedService,
        public filterService: FilterService
    ) {
        this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
            if (_res > 0) {
                this.getAttributes(_res);
                this.AttributeSelected.emit(null);
                this.AttributeModal = [];
            }
        });
    }

    ngOnChanges(changes: any): any {
        // map incoming attributes to modal (this has to be done because of some the old stupid structure)
        if (changes.AttributeModal.currentValue?.length > 0) {
            this.AttributeModal = changes.AttributeModal.currentValue.map(
                (item) => {
                    return {
                        childID: item.AtributoId ?? item.childID,
                        tipo: item.Tipo ?? item.tipo,
                        texto: item.Texto ?? item.texto,
                        companyId: item.EmpresaId,
                    };
                });
        }
    }

    ngOnInit(): any {
        const selectedCompanyId = localStorage.getItem('Empresa');
        this.getAttributes(selectedCompanyId);
        this.showChildren = this.selectionGenericService.leaveSelectionModal.AttributeList.length > 0 ;
        this.bajaSelected = this.sharedService.selectedSelectionTabId == 2;
    }

    getAttributes(companyId): any {
        this.selectionGenericService.GetAttributeList(companyId).subscribe(
            (res) => {
                if (res.code === 0) {
                    const attributeArray = JSON.parse(res.result);
                    
                    var pad =  attributeArray.map(function(item){return item.parent;});
                    var clean = pad.filter((arr, index, self) =>
                        index === self.findIndex((t) => (t === arr)));
                    this.padres = clean;
                    this.attributos$ = attributeArray;
                    
                    this.attributos$.forEach(item => {
                        item.texto = item.texto.replace(/\r/g, '').replace(/\n/g, '')
                        if (!this.parents.includes(item.parent)) {
                          this.parents.push(item.parent);
                        }
                        if (!this.childrenMap[item.parent]) {
                          this.childrenMap[item.parent] = [];
                        }
                        this.childrenMap[item.parent].push(item);
                      });
                }
            },
            (err) => {
                console.error(err);
            }
        );
    }
    
    onParentSelect(parent): void {
        this.selectedParent = parent;
        this.children = this.childrenMap[parent] || [];
      }

    saveAttribute(e): any {
        const attributeArray = new Array();
        const companyId = localStorage.getItem('Empresa');
        e.forEach((attribute) => {
            attributeArray.push({
                AtributoId: attribute.childID,
                EmpresaId: companyId,
                Tipo: attribute.tipo,
                Texto: attribute.texto,
            });
        });
        this.AttributeModalChanged.emit(e);
        this.AttributeSelected.emit(e);
    }
}
